import {combineReducers} from "redux";

import {bdApi} from "../app/api/bd_api";
import {headersSlice} from "../app/api/headers_api";
import {mpApi} from "../app/api/mp_api";
import {msStoreApi} from "../app/api/ms_store_api";
import {osmApi} from "../app/api/osm_api";
import {rpApi} from "../app/api/rp_api";
import {rpReducerObj} from "../app/rp_reducer";
import {surveyPreferencesActionListener} from "../application/actions/survey_preferences_action_listener";
import {afterAuthListener} from "../auth/listeners/after_auth_listener";
import {fetchUserDataAfterAuthListener} from "../auth/listeners/fetch_user_data_after_auth_listener";
import {authModalSlice} from "../auth/state/auth_modal_slice";
import {registrationFlowSlice} from "../auth/state/registration_flow_slice";
import {modularHouseOfferGalleryModalSlice} from "../modular_houses/store/modular_house_offer_gallery_modal";
import {modularHouseOfferLeadModalSlice} from "../modular_houses/store/modular_house_offer_lead_modal_slice";
import {yslabApi} from "../offer/detail/planner3D/components/api/yslab_api";
import {offerModalsSlice} from "../offer/state/offer_modals_slice";
import {vendorDetailSlice} from "../vendor/state/vendor_detail_slice";
import {vendorDetailViewSlice} from "../vendor/state/vendor_offer_list_slice";
import {notificationsSlice} from "./notifications/notifications_slice";

const rootReducerConfig = {
    ...rpReducerObj,
    //  Api
    [rpApi.reducerPath]: rpApi.reducer,
    [mpApi.reducerPath]: mpApi.reducer,
    [msStoreApi.reducerPath]: msStoreApi.reducer,
    [osmApi.reducerPath]: osmApi.reducer,
    [yslabApi.reducerPath]: yslabApi.reducer,
    [bdApi.reducerPath]: bdApi.reducer,
    //  Slices
    [headersSlice.name]: headersSlice.reducer,
    [notificationsSlice.name]: notificationsSlice.reducer,
    [authModalSlice.name]: authModalSlice.reducer,
    [registrationFlowSlice.name]: registrationFlowSlice.reducer,
    [offerModalsSlice.name]: offerModalsSlice.reducer,
    [vendorDetailViewSlice.name]: vendorDetailViewSlice.reducer,
    [modularHouseOfferLeadModalSlice.name]: modularHouseOfferLeadModalSlice.reducer,
    [modularHouseOfferGalleryModalSlice.name]: modularHouseOfferGalleryModalSlice.reducer,
    [vendorDetailSlice.name]: vendorDetailSlice.reducer
} as const;

export const rootReducer = combineReducers(rootReducerConfig);

export const apiMiddlewares = [rpApi.middleware, mpApi.middleware, msStoreApi.middleware, osmApi.middleware, yslabApi.middleware, bdApi.middleware];

export const listenerMiddlewares = [surveyPreferencesActionListener.middleware, fetchUserDataAfterAuthListener.middleware, afterAuthListener.middleware];
import {combineReducers} from "redux";

import {bdApi} from "../app/api/bd_api";
import {headersSlice} from "../app/api/headers_api";
import {mpApi} from "../app/api/mp_api";
import {msStoreApi} from "../app/api/ms_store_api";
import {osmApi} from "../app/api/osm_api";
import {rpApi} from "../app/api/rp_api";
import {rpReducerObj} from "../app/rp_reducer";
import {surveyPreferencesActionListener} from "../application/actions/survey_preferences_action_listener";
import {afterAuthListener} from "../auth/listeners/after_auth_listener";
import {fetchUserDataAfterAuthListener} from "../auth/listeners/fetch_user_data_after_auth_listener";
import {authModalSlice} from "../auth/state/auth_modal_slice";
import {registrationFlowSlice} from "../auth/state/registration_flow_slice";
import {modularHouseOfferGalleryModalSlice} from "../modular_houses/store/modular_house_offer_gallery_modal";
import {modularHouseOfferLeadModalSlice} from "../modular_houses/store/modular_house_offer_lead_modal_slice";
import {yslabApi} from "../offer/detail/planner3D/components/api/yslab_api";
import {offerModalsSlice} from "../offer/state/offer_modals_slice";
import {vendorDetailSlice} from "../vendor/state/vendor_detail_slice";
import {vendorDetailViewSlice} from "../vendor/state/vendor_offer_list_slice";
import {notificationsSlice} from "./notifications/notifications_slice";

const rootReducerConfig = {
    ...rpReducerObj,
    //  Api
    [rpApi.reducerPath]: rpApi.reducer,
    [mpApi.reducerPath]: mpApi.reducer,
    [msStoreApi.reducerPath]: msStoreApi.reducer,
    [osmApi.reducerPath]: osmApi.reducer,
    [yslabApi.reducerPath]: yslabApi.reducer,
    [bdApi.reducerPath]: bdApi.reducer,
    //  Slices
    [headersSlice.name]: headersSlice.reducer,
    [notificationsSlice.name]: notificationsSlice.reducer,
    [authModalSlice.name]: authModalSlice.reducer,
    [registrationFlowSlice.name]: registrationFlowSlice.reducer,
    [offerModalsSlice.name]: offerModalsSlice.reducer,
    [vendorDetailViewSlice.name]: vendorDetailViewSlice.reducer,
    [modularHouseOfferLeadModalSlice.name]: modularHouseOfferLeadModalSlice.reducer,
    [modularHouseOfferGalleryModalSlice.name]: modularHouseOfferGalleryModalSlice.reducer,
    [vendorDetailSlice.name]: vendorDetailSlice.reducer
} as const;

export const rootReducer = combineReducers(rootReducerConfig);

export const apiMiddlewares = [rpApi.middleware, mpApi.middleware, msStoreApi.middleware, osmApi.middleware, yslabApi.middleware, bdApi.middleware];

export const listenerMiddlewares = [surveyPreferencesActionListener.middleware, fetchUserDataAfterAuthListener.middleware, afterAuthListener.middleware];
